// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as MediaQuery$PorterinUtils from "../../../../../../../node_modules/@porterin/utils/src/hooks/MediaQuery.mjs";
import * as NextImage$PorterinFeature from "../../../../ui/components/NextImage.mjs";
import * as VehicleCapacityModuleScss from "../styles/VehicleCapacity.module.scss";

var styles = VehicleCapacityModuleScss;

function VehicleCapacityCmp(Props) {
  var icon = Props.icon;
  var capacity = Props.capacity;
  var isDesktop = MediaQuery$PorterinUtils.useMediaQuery("(min-width: 560px)");
  return React.createElement("div", {
              className: styles["vehicle-capacity-container"]
            }, React.createElement("div", {
                  className: styles["vehicle-capacity-image-wrapper"]
                }, React.createElement(NextImage$PorterinFeature.make, {
                      src: icon.path,
                      height: isDesktop ? 16.0 : 12.0,
                      width: isDesktop ? 16.0 : 12.0,
                      quality: 100.0,
                      alt: icon.alt_text
                    })), React.createElement("p", {
                  className: styles["vehicle-capacity"]
                }, capacity));
}

var make = VehicleCapacityCmp;

export {
  styles ,
  make ,
}
/* styles Not a pure module */
